import { render, staticRenderFns } from "./BotwQuiz.vue?vue&type=template&id=b6ea1bca&"
import script from "./BotwQuiz.vue?vue&type=script&lang=js&"
export * from "./BotwQuiz.vue?vue&type=script&lang=js&"
import style0 from "../styles/quiz.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports